var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.00098C12.2761 1.00098 12.5 0.777119 12.5 0.500977C12.5 0.255517 12.3231 0.0513692 12.0899 0.0090332L12 0.000976562H1C0.723858 0.000976562 0.5 0.224834 0.5 0.500977C0.5 0.746436 0.676875 0.950586 0.910124 0.992922L1 1.00098H12ZM6.50014 15.9988C6.7456 15.9988 6.9497 15.8218 6.99197 15.5885L7 15.4986L6.996 3.70477L10.6414 7.3531C10.8148 7.52683 11.0842 7.54636 11.2792 7.41154L11.3485 7.35375C11.5222 7.18034 11.5418 6.91094 11.407 6.71595L11.3492 6.64664L6.85745 2.14664C6.78495 2.07401 6.69568 2.02833 6.60207 2.00962L6.49608 1.99987C6.33511 1.99987 6.19192 2.076 6.10051 2.19419L1.64386 6.64607C1.44846 6.84119 1.44823 7.15777 1.64336 7.35317C1.8168 7.52686 2.08621 7.54634 2.28117 7.41148L2.35046 7.35368L5.996 3.71277L6 15.4989C6.00008 15.7751 6.224 15.9988 6.50014 15.9988Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.40a225ff.svg";
export { ForwardRef as ReactComponent };